import { useForm } from "react-hook-form";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import BaseModal from "../../../SharedComponents/components/Modals/BaseModal";
import ControllerRadioGroupForUserRating from "../../../SharedComponents/formComponents/uniqueFormComponents/ControllerRadioGroupForUserRating";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getFullName } from "../../../SharedComponents/utils/helpers/getFullName";
import ControllerTextArea from "../../../SharedComponents/formComponents/baseFormComponents/ControllerTextArea";
import { requestCreatePartOfferReview } from "../../reduxStore/sagas/requests/partOfferReviews";
import { setPartOffer } from "../../reduxStore/entities/partOffers";
import { useDispatch } from "react-redux";
import { RatingValueEnum } from "../../../SharedComponents/utils/enums/RatingValueEnum";

const PartOfferRateModal = ({
    open,
    setOpen,
    partOffer
}) => {
    const dispatch = useDispatch();
    const sellerName = getFullName(partOffer.User.firstname, partOffer.User.lastname);

    const methods = useForm();
    const { control, getValues } = methods;

    const getRatePayload = () => {
        const { rating, comment } = getValues();

        const payload = {
            part_offer_id: partOffer.part_offer_id,
            useridseller: partOffer.userid,
            rating: rating,
            comment: comment
        };

        return payload;
    };

    const determinePropName = (rating) => {
        let propName;

        if (rating === RatingValueEnum.POSTITIVE) {
            propName = "positive_rated_as_seller";
        }

        else if (rating === RatingValueEnum.NEGATIVE) {
            propName = "negative_rated_as_seller";
        };

        if (!propName) {
            throw new Error('Prop name is not determined');
        };

        return propName;
    };


    const handleStateUpdate = async (rating) => {
        const propName = determinePropName(rating);

        const callback = (oldVal) => {
            return {
                ...oldVal,
                User: {
                    ...oldVal.User,
                    [propName]: oldVal.User[propName] + 1
                }
            }
        };

        dispatch(setPartOffer(callback));
    };


    const handleConfirmRating = async () => {
        try {
            const payload = getRatePayload();

            const createdRate = await requestCreatePartOfferReview(payload);

            if (createdRate.data) {
                await handleStateUpdate(payload.rating);
                setOpen(false);
                alert('Uspesno ste ocenili prodavca!');
            };
        }

        catch (error) {
            alert(error.response.data.error);
        };
    };


    return (
        <BaseModal
            open={open}
            setOpen={setOpen}
            externalStyle={styles.externalModalStyle}
        >
            <div style={styles.topLevelContainer}>
                <div>
                    <div style={styles.mainContainer}>
                        <p style={styles.title}>
                            Oceni saradnju sa prodavcem
                        </p>
                    </div>

                    <div style={styles.itemsContainer}>
                        <p style={styles.text}>
                            Hvala što koristiš SmartPart sistem!
                        </p>
                        <p style={styles.text}>
                            Pomozi nam da budemo još bolji u našoj usluzi posredovanja -
                        </p>

                        <div style={styles.rateComponent}>
                            <p style={styles.text}>
                                {`Oceni saradnju sa prodavcem ${sellerName}:`}
                            </p>
                        </div>
                    </div>

                    <div>
                        <ControllerRadioGroupForUserRating
                            name={"rating"}
                            control={control}
                        />

                        <div style={styles.controllerTextArea}>
                            <ControllerTextArea
                                name={"comment"}
                                control={control}
                                placeholder={"Upiši komentar o saradnji"}
                                width={"100%"}
                                height={180}
                            />
                        </div>
                    </div>

                </div>

                <div style={styles.modalFooterContariner}>
                    <div style={styles.modalFooterContarinerUpperRow}>
                        <div
                            onClick={() => setOpen(false)}
                            style={styles.clickable}
                        >
                            <p style={styles.backTitle}>
                                Odustani
                            </p>
                        </div>

                        <BaseButton
                            onClick={() => handleConfirmRating()}
                            variant={ButtonVariantEnum.BLACK}
                            text={"Potvrdi ocenu"}
                            IconComponent={RightArrowExtendedIconSVG}
                        />
                    </div>
                </div>
            </div>

        </BaseModal>
    );
};


export default PartOfferRateModal;

const styles = {
    externalModalStyle: {
        minHeight: "614px",
        width: "600px",
        paddingBottom: 40,
        paddingInline: 80
    },
    clickable: {
        cursor: 'pointer'
    },
    controllerTextArea: {
        marginTop: 40
    },
    rateComponent: {
        marginTop: 20
    },
    topLevelContainer: {
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 40
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 40
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "rgba(0, 0, 0, 0.87)"
    },
    text: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.87)"
    },
    itemsContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    backTitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "20px",
        color: "#5B21B6"
    },
    modalFooterContariner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
    },
    modalFooterContarinerUpperRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20
    },
    footerInfoText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "#000000de"
    }
}